import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-charge-type',
  templateUrl: './charge-type.component.html',
  styleUrls: ['./charge-type.component.css']
})
export class ChargeTypeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
